{"id":"PrivacyPolicyButton","prefabs":{"default":{"children":[{"component":"PrivacyPolicyButton","options":"options:*"}]}}}